import {createApp} from "petite-vue";
import initVideo from "./components/video";
import SimpleLightbox from "simple-lightbox";
import initPagination from "./components/pagination";
import Swiper from "swiper";
import {Keyboard, Navigation} from "swiper/modules";
import {initMap} from "./components/map";
import {isInViewport} from "./utils/is-in-viewport";
import initSearch from "./components/search";


import.meta.glob(['@images/**']);
import.meta.env.DEV && import("@styles/main.sass");

declare global {
    var Alpine: any;
    var Livewire: any;

    interface salonData {
        ID: number
        address: string
        claim: string
        email: string
        facebook_link: string
        instagram_link: string
        lat: string
        lng: string
        partner: string
        permalink: string
        phone: string
        subtitle: string
        thumbnail: string
        title: string
    }

    const salonsData: salonData[]
}

interface Header {
    opened: boolean;

    handleOpenedHeader(state: boolean): void;
}

const headerEl = document.querySelector<HTMLElement>('[data-header]'),
    headerScope: Header = {
        opened: false,

        handleOpenedHeader(state) {
            document.body.classList.toggle("u-hiddenOverflow", state);
        },
    };

if (headerEl) {
    createApp(headerScope).mount(headerEl);

}

//------------------------------------Why - šoupací fotka

(() => {
    const input = document.querySelector<HTMLInputElement>('.before-after-slider input[type="range"]');
    const figure = document.querySelector<HTMLElement>(".before-after-slider");

    if (input && figure) {
        input.addEventListener("input", () => {
            const value = Number(input.value);
            figure.style.setProperty("--rangeValue", value.toString());
        });
    }
})();

//----------------------------------------header změnšování

(() => {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    function onScroll() {
        if (window.scrollY > 0) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    }

    window.addEventListener('scroll', onScroll);
})();


//----------------------------------------Lightbox

(() => {

    const galleryElement = document.querySelector(".wp-block-gallery");
    new SimpleLightbox({
        elements: ".wp-block-gallery .wp-block-image > a",
    });
})();

//----------------------------------Swiper

(() => {
    const swiperContainer = document.querySelector("[data-swiper]") as HTMLElement | null;

    if (!swiperContainer) return;

    const swiperInstance = new Swiper(swiperContainer, {
        modules: [Keyboard, Navigation],
        slidesPerView: 4,
        slidesPerGroup: 1,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        grabCursor: true,
        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },
        allowTouchMove: true,
    });
})();

(() => {
    const swiperInstaContainer = document.querySelector("[data-insta-swiper]") as HTMLElement | null;

    if (!swiperInstaContainer) return;

    const swiperInsta = new Swiper(swiperInstaContainer, {
        modules: [Keyboard],
        slidesPerView: "auto",
        slidesPerGroup: 1,
        grabCursor: true,
        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },
        allowTouchMove: true,
        loop: true,
    });
})();


//----------------------------------------LoggedIn sekce
(() => {
    const headerLogin = document.getElementById("header-login") as HTMLButtonElement | null;
    const headerLogged = document.getElementById("header-logged") as HTMLElement | null;
    const closeButton = document.getElementById("header-logged-close") as HTMLButtonElement | null;

    function toggleHeaderLogged(event: Event) {
        event.stopPropagation();
        if (headerLogged) headerLogged.classList.toggle("is-visible");
    }

    function handleOutsideClick(event: Event) {
        if (headerLogged && headerLogin && !headerLogged.contains(event.target as Node) && !headerLogin.contains(event.target as Node)) {
            headerLogged.classList.remove("is-visible");
        }
    }

    headerLogin?.addEventListener("click", toggleHeaderLogged);
    closeButton?.addEventListener("click", () => headerLogged?.classList.remove("is-visible"));
    document.addEventListener("click", handleOutsideClick);
})();

//--------------------------------------------show/hide password

(() => {
    const toggles = document.querySelectorAll(".FormPassword-toggle");

    toggles.forEach((toggle) => {
        toggle.addEventListener("click", () => {
            const input = toggle.previousElementSibling as HTMLInputElement | null;
            if (!input) return;

            const eyeIcon = toggle.querySelector(".icon-eye") as HTMLElement | null;
            const eyeSlashIcon = toggle.querySelector(".icon-eye-slash") as HTMLElement | null;

            if (input.type === "password") {
                input.type = "text";
                toggle.setAttribute("aria-label", "Skrýt heslo");
            } else {
                input.type = "password";
                toggle.setAttribute("aria-label", "Zobrazit heslo");
            }

            eyeIcon?.classList.toggle("hidden");
            eyeSlashIcon?.classList.toggle("hidden");
        });
    });
})();


//---------------------------------------scrollbehavior pro odkaz na HP

(() => {
    document.querySelectorAll('a[href*="#"]').forEach(anchor => {
        anchor.addEventListener("click", event => {
            const [page, targetId] = anchor.getAttribute("href").split("#");
            if (page && targetId) {
                event.preventDefault();
                localStorage.setItem("scrollToId", targetId);
                window.location.href = page;
            }
        });
    });

    const targetId = localStorage.getItem("scrollToId");
    if (targetId) {
        localStorage.removeItem("scrollToId");
        setTimeout(() => {
            const target = document.getElementById(targetId);
            if (target) window.scrollTo({
                top: target.getBoundingClientRect().top + window.scrollY - 192,
                behavior: "smooth"
            });
        }, 500);
    }
})();


(async () => {
    initSearch();
    initPagination();
    await initVideo();

    const mapEl = document.querySelector<HTMLElement>("[data-map]")
    mapEl && (document.body.classList.contains('archive') || isInViewport(mapEl, 4)) ? await initMap(mapEl)
        : window.addEventListener("scroll", async () => {
            isInViewport(mapEl, 4) && await initMap(mapEl)
        })
})();

//----------------------------------------O nás linky
(() => {
    const links = document.querySelectorAll<HTMLAnchorElement>('.CategoriesLink')

    links.forEach(link => {
        link.addEventListener('click', () => {
            links.forEach(l => l.classList.remove('CategoriesLink--active'))
            link.classList.add('CategoriesLink--active')
        })
    })
})();

//--------------------------------------------Footer open/close

(() => {
    function toggleDetailsOpen() {
        const details = document.querySelectorAll('.FooterMiddle-menu');
        const isDesktop = window.innerWidth >= 512;

        details.forEach(detail => {
            if (isDesktop) {
                detail.setAttribute('open', '');
            } else {
                detail.removeAttribute('open');
            }
        });
    }

    document.addEventListener('DOMContentLoaded', () => {
        setTimeout(toggleDetailsOpen, 100);
    });

    window.addEventListener('resize', () => {
        setTimeout(toggleDetailsOpen, 100);
    });
})();